import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-investment',
	templateUrl: './investment.component.html',
	styleUrls: ['./investment.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InvestmentComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/investment/investment.component.ts